import {
  EXPERIENCE_LEVEL_OPTIONS,
  isExperienceGroupChecked,
} from './experienceLevelOptions';

/**
 * Count of applied filters for the "Filter and order · N" badge.
 * Order selection is excluded (Best match leaves the page).
 */
export default function getAppliedFilterCount(filter) {
  if (!filter) return 0;

  let count = 0;

  if (filter.selectedRoles && filter.selectedRoles.length > 0) {
    count += filter.selectedRoles.length;
  }

  if (filter.locationText) {
    count += 1;
  }

  if (filter.remote) {
    count += 1;
  }

  EXPERIENCE_LEVEL_OPTIONS.forEach((option) => {
    if (isExperienceGroupChecked(filter.experienceLevels, option)) {
      count += 1;
    }
  });

  if (filter.hiringCapacities) {
    count += filter.hiringCapacities.filter((item) => item.isChecked).length;
  }

  if (filter.internal) {
    count += 1;
  }

  // Open to applications defaults ON; only count when the user turns it off.
  if (filter.status === false) {
    count += 1;
  }

  if (filter.searchTerm) {
    count += 1;
  }

  return count;
}
